












































































































































import ValidateInput from '@/components/common/input/ValidateInput.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';

import {Vue, Component, Prop} from 'vue-property-decorator';
import {State, namespace} from 'vuex-class';
import {Mall, Mds} from 'supporter';

import {ncpPopup} from '@/utils/commonUtils';
import {isEmailValidated} from '@/utils/validateUtils';

const mallModule = namespace('mall');
@Component({
  components: {
    ValidateInput, 
    CompSelectBox, 
  }
})
export default class PartnerDetail extends Vue {
  @Prop() private type!: string;
  @Prop() private oldPartner?: any;

  // 파트너명
  private partnerName = '';
  private partnerNameOptions = {
    name: 'partnerName',
    type: 'partner-name',
    maxlength: 42,
  };
  private existsStatus = '';
  private existsFlg = true;
  private resetExists() {
    this.existsStatus = '';
    this.existsFlg = true;
  }
  private async existsCheck() {
    if (this.partnerName.trim().length === 0) {
      alert(this.$t('PARTNER_ERR_NAME_NULL'));
      (this.$refs.partnerName as any).focus();
      return;
    }
    const request = {
      params: {
        name: this.partnerName
      }
    };

    const {data} = await this.$api.getPartnersExists(request);
    if (data.exists) {
      this.existsStatus = 'NG';
    } else {
      this.existsStatus = 'OK';
      this.existsFlg = false;
    }
  }

  // 마스터 운영자명
  private adminName = '';
  private adminNameOptions = {
    name: 'adminName',
    type: 'no-symbol-strict'
  };
  private adminNameErrFlg = '';

  // e메일 주소
  private emailId = '';
  private emailIdErrFlg = '';
  private emailIdOptions = {
    name: 'emailId',
    type: 'email-local'
  };
  private emailDomain = '';
  private emailDomainErrFlg = '';
  private emailDomainOptions = {
    name: 'emailDomain',
    type: 'email-domain'
  };
  
  private bShowGuide: boolean = false;

  // 거래 쇼핑몰
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: number = 0;
  private get mallList() {
    const list: any = [
      {
        value: 0,
        name: this.$t('COMMON_SELECT')
      }
    ];
    if (this.malls) {
      this.malls.forEach(mall => {
        if (mall.used) {
          list.push({
            value: mall.mallNo,
            name: mall.mallName
          });
        }
      });
    }
    return list;
  }
  private async changeMall() {
    this.contractUsed = 'N';
    this.contractContent = '';
    this.merchandiserNo = 0;
    this.mdList = [];
    this.mdErrFlg = false;
    if (this.mallNo !== 0) {
      const {data} = await this.$api.getAdminsServiceMerchandisers({params: {mallNo: this.mallNo.toString()}});
      if (data.length === 0) {
        this.mdErrFlg = true;
        return;
      }
      this.changeOptionIndex(data);
    }
  }

    private changeOptionIndex(data: Mds[]) {
     const mallsMdsMap = data.map(({name, id, adminNo})=>({
      name: `${name}(${id})`,
      adminNo,
      id,
    }))
    this.mdList = [...mallsMdsMap].sort((a,b)=>a.name>b.name?1:-1)
    this.merchandiserNo = mallsMdsMap[0].adminNo
  }

  // 입점 계약서 사용
  private contractUsed = 'N';
  private contractContent = '';
  private get popBtnName() {
    let btnName: any = '';
    if (this.contractContent === '') {
      btnName = this.$t('PARTNER_ENROLLMENT');
    } else {
      btnName = this.$t('PARTNER_CHANGE');
    }
    return btnName;
  }
  private async clickContractUsed(used: boolean) {
    if (used) {
      const {data} = await this.$api.getMallsConfigurations({pathParams: {mallNo: this.mallNo.toString()}, params: {key: 'PARTNER_CONTRACT'}});
      // this.contractContent = (data.entryContractContentsOfMall || data.standingPointContract) ?? '';
      this.contractContent = data.entryContractContentsOfMall;
    } else {
      this.contractContent = '';
    }
  }

  // 파트너 노출 설정
  private dependencyYn = false;

  private clickDependencyYn(used: boolean) {
    this.dependencyYn = used
  }

  private openPop() {
    (window as any).setTemplate = this.callback;
    let url = '/contract/standingPointContract/popup?type=normal';
    url += `&mallNo=${this.mallNo}`;
    url += `&updateYn=${this.contractContent !== ''}`;
    url += '&callback=setTemplate';
    if (this.contractContent) sessionStorage.setItem('contractContent', this.contractContent);
    ncpPopup(url, this.$t('PARTNER_POP_NAME') as string, 1000, 700);
  }
  private callback(content: any) {
    (window as any).setTemplate = undefined;
    sessionStorage.removeItem('contractContent');
    this.contractContent = content;
  }

  // 담당MD명
  private merchandiserNo = 0;
  private mdList: Mds[];
  private mdErrFlg = false;

  // 수수료율
  private commissionRate? = null;
  private rateErrFlg = false;
  private rateOptions = {
    name: 'commissionRate',
    type: 'dec',
    digits: 1,
    limit: 2
  };

  // 전달 메모
  private memo = '';

  //파트너 등록
  private async register() {
    if (this.checkAll()) {
      if (this.type === 'new') {
        const request = {
          data: {
            adminName: this.adminName,
            commissionRate: this.commissionRate,
            merchandiserNo: this.merchandiserNo,
            partnerName: this.partnerName,
            memo: this.memo,
            mallNo: this.mallNo,
            contractContent: this.contractContent,
            adminEmail: `${this.emailId}@${this.emailDomain}`,
            dependencyYn: this.dependencyYn,
          }
        };
        await this.$api.postPartners(request);
        alert(this.$t('PARTNER_NEW_REGISTER_MAG'));
        this.$router.push('/partner/list');
      } else if (this.type === 'contract') {
        const request = {
          data: {
            partnerNo: this.oldPartner.partnerNo,
            commissionRate: Number(this.commissionRate),
            merchandiserNo: this.merchandiserNo,
            memo: this.memo,
            mallNo: this.mallNo,
            contractContent: this.contractContent
          }
        };
        await this.$api.postContracts(request);
        alert(this.$t('PARTNER_CONTRACT_REGISTER_MAG'));
        this.$router.go(-1);
      } else if (this.type === 'copy') {
        const request = {
          pathParams: {
            partnerNo: this.oldPartner.partnerNo
          },
          data: {
            adminName: this.adminName,
            commissionRate: Number(this.commissionRate),
            merchandiserNo: this.merchandiserNo,
            partnerName: this.partnerName,
            memo: this.memo,
            mallNo: this.mallNo,
            contractContent: this.contractContent,
            adminEmail: `${this.emailId}@${this.emailDomain}`,
            dependencyYn: this.dependencyYn,
          }
        };
        await this.$api.postPartnersPartnerNoCopy(request);
        alert(this.$t('PARTNER_COPY_REGISTER_MAG'));
        this.$router.go(-1);
      }
    }
  }
  private checkAll() {
    if (this.type !== 'contract') {
      // 파트너명
      if (this.partnerName.trim().length === 0) {
        alert(this.$t('PARTNER_ERR_NAME_NULL'));
        (this.$refs.partnerName as any).focus();
        return false;
      }
      if (this.existsFlg) {
        const msg = this.type === 'new' ? this.$t('PARTNER_NEW_ERR_NOT_CHECK_EXISTS') : this.$t('PARTNER_COPY_ERR_NOT_CHECK_EXISTS');
        alert(msg);
        (this.$refs.partnerName as any).focus();
        return false;
      }
      // 마스터 운영자명
      if (this.adminName.trim().length === 0) {
        alert(this.$t('PARTNER_ERR_ADMIN_NAME_NULL'));
        (this.$refs.adminName as any).focus();
        return false;
      }
      // e메일 주소
      if (this.emailId.trim().length === 0) {
        const msg = this.type === 'new' ? this.$t('PARTNER_NEW_ERR_EMAIL_NULL') : this.$t('PARTNER_COPY_ERR_EMAIL_NULL');
        alert(msg);
        (this.$refs.emailId as any).focus();
        return false;
      }
      if (this.emailDomain.trim().length === 0) {
        const msg = this.type === 'new' ? this.$t('PARTNER_NEW_ERR_EMAIL_NULL') : this.$t('PARTNER_COPY_ERR_EMAIL_NULL');
        alert(msg);
        (this.$refs.emailDomain as any).focus();
        return false;
      }
      if (!isEmailValidated(`${this.emailId}@${this.emailDomain}`)) {
        alert(this.$t('PARTNER_ERR_EMAIL_FORMAT'));
        (this.$refs.emailId as any).focus();
        return false;
      }
    }

    if (this.type === 'contract') {
      // 마스터계정 ID
      if (this.oldPartner.adminId === '') {
        alert(this.$t('PARTNER_CONTRACT_ERR_ADMIN_ID_NULL'));
        return false;
      }
    }
    // 거래 쇼핑몰
    if (this.mallNo === 0) {
      alert(this.$t('PARTNER_ERR_MALL_NO_NULL'));
      (this.$refs.mallNo as any).focus();
      return false;
    }
    // 담당MD명
    if (this.merchandiserNo === 0) {
      alert(this.$t('PARTNER_ERR_MD_NO_NULL'));
      (this.$refs.merchandiserNo as any).focus();
      return false;
    }

    // 수수료율
    if (this.commissionRate === '' || this.commissionRate === null) {
      alert(this.$t('PARTNER_ERR_RATE_NULL'));
      (this.$refs.commissionRate as any).focus();
      return false;
    }
    // 입점 계약서 사용
    if (this.contractUsed === 'Y' && this.contractContent === '') {
      alert(this.$t('PARTNER_ERR_CONTRACT_NULL'));
      (this.$refs.popBtn as any).focus();
      return false;
    }

    if (this.dependencyYn && !confirm('해당 파트너사의 노출 설정을 ‘노출 안 함’으로 변경하시겠습니까?\n노출 안 함 으로 설정 시 파트너 조회결과에 노출되지 않습니다.')) {
      // 파트너 노출설정 여부
      return false;
    }

    if (this.type !== 'contract') {
      return confirm(this.$t('PARTNER_REGISTER_CONFIRM') as string);
    }

    return true;
  }

  // 취소
  private cancel() {
    let backFlg = true;
    if (this.type === 'contract') {
      backFlg = confirm(this.$t('PARTNER_CONTRACT_CANCEL_CONFIRM_MSG') as string);
    }
    if (this.type === 'copy') {
      backFlg = confirm(this.$t('PARTNER_COPY_CANCEL_CONFIRM_MSG') as string);
    }
    if (backFlg) {
      this.$router.go(-1);
    }
  }

  private showGuide (): void {
    this.bShowGuide = true;
  }
  private hideGuide(): void {
    this.bShowGuide = false;
  }


  private async mounted() {
    await this.fetchMalls();
  }
}
